import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

// the translations
import resources from './resources'

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: import.meta.env.VITE_APP_LANGUAGE || 'nl',

    defaultNS: 'common',

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  })

export default i18n
